import { render, staticRenderFns } from "./DeepLinkRedirect.vue?vue&type=template&id=8e80b2c2&"
import script from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"
export * from "./DeepLinkRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports